import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import rhumbConfig from '../rhumb-config.yaml';
import { history } from './router/history';
import { tracker } from './usage/tracker';
import { setPrimaryTracker } from 'usage-tracker-container';
import { Provider } from 'react-redux';
import { getAuth } from './reducers/authReducer';
import { store } from './store';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import BasicI18nSetup from 'I18n/init/setup/BasicI18nSetup';
import 'I18n/init/data/allTimezones';
import SettingsApplication from './components/SettingsApplication';
import { renderWithNavCopilot } from 'quartz-core/client-with-copilot';
import UIApplication from 'UIComponents/app/UIApplication';
import { jsx as _jsx } from "react/jsx-runtime";
export class App {
  handleSetupFinished() {
    renderWithNavCopilot( /*#__PURE__*/_jsx(UIApplication, {
      name: "crm-settings-task-reminders",
      children: /*#__PURE__*/_jsx(Provider, {
        store: store,
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          config: rhumbConfig,
          history: historyAdapter(history),
          children: /*#__PURE__*/_jsx(SettingsApplication, {})
        })
      })
    }), {
      layoutType: 'sidebar'
    });
  }
  startAuth() {
    return store.dispatch(getAuth()).then(action => {
      return action.payload;
    });
  }
  start() {
    if (window.performance && window.performance.mark) {
      window.performance.mark('mark_setup_loaded');
    }

    // Return a promise that is resolved when every promise in Auth initializers
    // has resolved. AKA, when everything is ready.
    return this.startAuth().then(auth => BasicI18nSetup.setup({
      lang,
      user: auth.user,
      portal: auth.portal
    }).then(() => {
      if (window.performance && window.performance.mark) {
        window.performance.mark('mark_setup_fetched');
      }
      setPrimaryTracker(tracker);
      this.handleSetupFinished();
    })).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
}